import { cn } from '@shared/lib/cn'
import { Link, useMatchRoute } from '@tanstack/react-router'
import type { ComponentType, SVGAttributes } from 'react'
import { HiMiniHome, HiMiniSparkles, HiMiniUser } from 'react-icons/hi2'

function NavItem({
  icon: Icon,
  label,
  isActive,
}: {
  readonly icon: ComponentType<SVGAttributes<SVGElement>>
  readonly label: string
  readonly isActive: boolean
}) {
  return (
    <>
      <Icon className="text-xl" />
      <span
        className={cn(
          'typo-footnote font-medium',
          isActive ? 'text-primary' : 'text-muted-foreground',
        )}
      >
        {label}
      </span>
    </>
  )
}

const navLinkClass = (isActive: boolean) =>
  cn(
    'flex flex-1 cursor-pointer flex-col items-center justify-center gap-0.5 transition-colors',
    isActive ? 'text-primary' : 'text-muted-foreground',
  )

export function BottomNav() {
  const matchRoute = useMatchRoute()

  const isHome = !!matchRoute({ to: '/', fuzzy: false })
  const isSaju = !!matchRoute({ to: '/saju/$sajuType', fuzzy: true })
  const isMypage = !!matchRoute({ to: '/mypage', fuzzy: false })

  return (
    <nav className="sticky bottom-0 z-sticky border-t border-border/40 bg-bg-base/60 backdrop-blur-xl shadow-(--elevation-sm)">
      <div className="flex h-14 items-stretch">
        <Link to="/" className={navLinkClass(isHome)}>
          <NavItem icon={HiMiniHome} label="홈" isActive={isHome} />
        </Link>
        <Link
          to="/saju/$sajuType"
          params={{ sajuType: 'classic' }}
          className={navLinkClass(isSaju)}
        >
          <NavItem icon={HiMiniSparkles} label="사주 풀이" isActive={isSaju} />
        </Link>
        <Link to="/mypage" className={navLinkClass(isMypage)}>
          <NavItem icon={HiMiniUser} label="마이" isActive={isMypage} />
        </Link>
      </div>
      {/* Safe area for iOS home indicator */}
      <div className="h-[env(safe-area-inset-bottom)]" />
    </nav>
  )
}
